import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMutation, useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

import { Button } from 'antd';
import { DeleteFilled, EditOutlined, PlusOutlined } from '@ant-design/icons';
import Page from 'components/Page';
import Table from 'components/Table';

import globalMessages from 'translations/messages';
import EditSurveyCategoryForm from './EditSurveyCategoryForm';

const QUERY = gql`
  query {
    surveyCategories { id title surveyGroupCount }
  }
`;

const DELETE = gql`
  mutation DeleteSurveyCategory($id: ID!) {
    deleteSurveyCategory(id: $id) {
      id
    }
  }
`;

const columns = [
  {
    dataIndex: 'title',
    title: <FormattedMessage {...globalMessages.title} />,
    defaultSortOrder: 'ascend',
  },
  {
    dataIndex: 'surveyGroupCount',
    title: <FormattedMessage {...globalMessages.surveys} />,
    type: 'number',
  },
];

const SurveyCategories = () => {
  const { data, loading, refetch } = useQuery(QUERY);
  const [edit, setEdit] = useState(false);
  const [deleteCategory] = useMutation(DELETE, { onCompleted: refetch });

  const actions = (record) => (
    <Button icon={<EditOutlined />} onClick={() => setEdit(record)}>
      Edit
    </Button>
  );

  const actionsMenuItems = (record) => [
    {
      key: 'delete',
      icon: <DeleteFilled />,
      label: 'Delete',
      danger: true,
      onClick: () => deleteCategory({ variables: { id: record.id } }),
      visible: record.surveyGroupCount === 0,
    },
  ];

  const onCreate = () => {
    setEdit(false);
    refetch();
  };

  return (
    <Page>
      <Page.Header
        title={<FormattedMessage {...globalMessages.industries} />}
      />
      <Page.Content>
        <Table
          loading={loading}
          columns={columns}
          dataSource={data?.surveyCategories}
          actions={actions}
          actionsMenuItems={actionsMenuItems}
          footerActions={(
            <Button type="primary" onClick={() => setEdit({})} icon={<PlusOutlined />}>
              <FormattedMessage {...globalMessages.create} />
            </Button>
          )}
        />
        <EditSurveyCategoryForm category={edit} onCancel={() => setEdit(false)} onCreate={onCreate} />
      </Page.Content>
    </Page>
  );
};

export default SurveyCategories;
